import jwtAuthAxios from "./auth/jwtAuth";

const tripServices = {};

tripServices.getTrips = async (params, xlsxFormat = false) => {
    if(xlsxFormat) { jwtAuthAxios.defaults.headers.common['Accept'] = 'application/xlsx'; }
    // en este get debe venir la info de delivery.sap_synched para cada delivery de cada trip
    // trip.deliveries[0].sap_synched
    // no hay ninguna traducción de lo que llega del backend a lo que se muestra en el frontend
    // si del backend viene sap_synched hay que llamarlo así en el frontend
    // nada lo modifica a sapSynched
    const {data} = await jwtAuthAxios.get(`/trips${params}${xlsxFormat ? '' : ''}`, xlsxFormat ? { responseType: 'arraybuffer' } : {});
    if (xlsxFormat) { jwtAuthAxios.defaults.headers.common['Accept'] = 'application/json'; }
    return data;
};

tripServices.getTripDetails = async (trip_id, params = "") => {
    const {data} = await jwtAuthAxios.get(`/trips/${trip_id}${params}`);
    return data;
};

tripServices.calculateRouteOrder = async (trip_id, params={}) => {
    const {data} = await jwtAuthAxios.post(`/trips/${trip_id}/calculate_route_order`, params);
    return data;
};

tripServices.updateTrip = async (trip_id, params) => {
    const {data} = await jwtAuthAxios.put(`/trips/${trip_id}`, params);
    return data;
};

export default tripServices;